@if (isEquipmentComponentsVisible) {
  <div class="my-equipment-component">
    <div class="my-equipment-component__title" [attr.data-test]="'desc-tableTitle'">
      {{ 'my-contracts.equipment-components-title' | translate }}
    </div>
    <div class="table">
      <div class="table__header" [attr.data-test]="'desc-tableHeader'">
        @for (attribute of attributes; track attribute) {
          <div class="table__column" [attr.data-test]="'desc-header' + attribute.dataTestTitle">{{ attribute.key | translate }}</div>
        }
      </div>
      @for (item of equipmentData; track item) {
        <div class="table__data" [attr.data-test]="'desc-tableData'">
          @for (attribute of attributes; track attribute) {
            <div class="table__column" [attr.data-test]="'desc-data' + attribute.dataTestTitle">{{ getAttribute(item, attribute.title) }}
            </div>
          }
        </div>
      }
    </div>
  </div>
}
